import { ConnectedSettingsPage } from "controller/connected-settings";
import { ConnectedFullScreenView } from "controller/fullscreen-view";
import { ConnectedMessages } from "controller/messages";
import { RouteCloseSidebar } from "controller/sidebar/connected-close-sidebar";
import { ConnectedNavigationSidebar } from "fleet/controller/navigation/connected-navigation-sidebar";
import { ConnectedOverview } from "fleet/controller/overview/connected-overview";
import Varz from "fleet/controller/varz";
import { renderApplicationsRoutes } from "fleet/routes/applications";
import { renderDeviceRoutes } from "fleet/routes/devices";
import { renderDiagnosticRoutes } from "fleet/routes/diagnostics";
import { renderNetworkRoutes } from "fleet/routes/networks";
import { renderReportsRoutes } from "fleet/routes/reports";
import { renderStrategyV2Routes } from "fleet/routes/strategy-v2";
import { renderUserRoutes } from "fleet/routes/users";
import { BaseSite } from "fleet/view/application/base-site";
import { FleetSideBar } from "fleet/view/sidebar";
import { Pendo } from "integrations/pendo";
import PropTypes from "prop-types";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { renderAuthRoutes } from "routes/auth";
import { BasicLoader } from "ui/loader";
import { PrivateRoute } from "ui/private-route";
import { Error404View } from "view/error";
import { RedirectView } from "view/redirect/redirect-view";

class Main extends React.PureComponent {
  static get propTypes() {
    return {
      featureFlags: PropTypes.object,
      isAuthenticated: PropTypes.bool.isRequired,
      location: PropTypes.object.isRequired,
      storesLoaded: PropTypes.bool,
      user: PropTypes.object,
    };
  }

  _renderRoutes() {
    const { featureFlags } = this.props;

    return (
      <Switch>
        {renderApplicationsRoutes()}
        {renderAuthRoutes()}
        {featureFlags ? renderDeviceRoutes(featureFlags) : renderDeviceRoutes()}
        {renderDiagnosticRoutes()}
        {renderNetworkRoutes()}
        {renderReportsRoutes()}
        {renderStrategyV2Routes()}
        {renderUserRoutes()}

        <Route
          exact
          path="/"
          render={() => {
            return <Redirect to="/overview" />;
          }}
        />
        <PrivateRoute exact path="/overview" component={ConnectedOverview} />
        <PrivateRoute
          exact
          path="/settings"
          component={ConnectedSettingsPage}
        />
        <PrivateRoute exact path="/varz" component={Varz} />
        <Route path="/redirect" component={RedirectView} />

        <Route component={Error404View} />
      </Switch>
    );
  }

  _renderDashboard() {
    const { location } = this.props;

    return (
      <BaseSite>
        <ConnectedNavigationSidebar location={location} />
        {this._renderRoutes()}
      </BaseSite>
    );
  }

  render() {
    const { isAuthenticated, storesLoaded, user } = this.props;

    if (!storesLoaded) {
      return (
        <BasicLoader className="page-loader">
          Cortex Fleet Loading...
        </BasicLoader>
      );
    }

    return (
      <div className="main-container">
        <Pendo user={user} />
        <RouteCloseSidebar />
        <ConnectedFullScreenView />
        <ConnectedMessages />
        {isAuthenticated ? this._renderDashboard() : this._renderRoutes()}
        <FleetSideBar />
      </div>
    );
  }
}

export { Main };
